<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <h3>Veja os principais planos disponíveis para você</h3>
        <div class="desktop">
          <carousel :perPage="4" :navigationEnabled="true">
            <slide v-for="plan in plans" :key="plan.id">
              <div class="card-deck">
                <div class="card">
                  <div class="card-body">
                    <span
                      style="display: block; text-align: center; color: #A9CD84;"
                      >Internet</span
                    >
                    <h5 class="card-title text-center">
                      {{ plan.download_speed }}EGA
                    </h5>

                    <div class="box">
                      <p class="m-0 d-flex align-items-center card-title-item">
                        <img
                          class="mr-2"
                          src="img/icons/internet-servicos.png"
                          alt=""
                        />
                        INTERNET FIXA
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        {{ plan.download_speed }} Residencial
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        Internet - FIBRA ÓPTICA
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        Franquia: ILIMITADA
                      </p>
                      <hr />
                    </div>

                    <span>A partir de:</span>
                    <p class="card-value">
                      R${{ plan.price.toString().replace(".", ",") }}
                      <span>por mês</span>
                    </p>

                    <div class="container_contratar">
                      <a href="#update-plan"
                        ><button class="btn-contratar" @click="next(plan.id)">
                          Escolher
                        </button></a
                      >
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="mobile">
          <carousel :perPage="1" :navigationEnabled="true">
            <slide v-for="plan in plans" :key="plan.id">
              <div class="card-deck">
                <div class="card">
                  <div class="card-body">
                    <span
                      style="display: block; text-align: center; color: #A9CD84;"
                      >Internet</span
                    >
                    <h5 class="card-title text-center">
                      {{ plan.download_speed }}EGA
                    </h5>

                    <div class="box">
                      <p class="m-0 d-flex align-items-center card-title-item">
                        <img
                          class="mr-2"
                          src="img/icons/internet-servicos.png"
                          alt=""
                        />
                        INTERNET FIXA
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        {{ plan.download_speed }} Residencial
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        Internet - FIBRA ÓPTICA
                      </p>
                      <p class="m-0 d-flex align-items-center f16">
                        <img
                          class="mr-2"
                          src="img/icons/check-circle.svg"
                          alt=""
                        />
                        Franquia: ILIMITADA
                      </p>
                      <hr />
                    </div>

                    <span>A partir de:</span>
                    <p class="card-value">
                      R${{ plan.price.toString().replace(".", ",") }}
                      <span>por mês</span>
                    </p>

                    <div class="container_contratar">
                      <a href="#update-plan"
                        ><button class="btn-contratar" @click="next(plan.id)">
                          Escolher
                        </button></a
                      >
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import { updateList } from "../../helpers";

export default {
  components: {
    Carousel,
    Slide
  },
  data: function() {
    return {
      plans: []
    };
  },
  methods: {
    ...mapActions(["fetchPlans"])
  },
  async mounted() {
    try {
      const plansToShow = updateList.get(Number(this.$route.query.planId));
      if (!plansToShow) {
        Swal.fire(
          "Ops!",
          "O plano deste ponto não está elegível para atualização.",
          "error"
        );
        return;
      }
      const data = await this.fetchPlans();
      this.plans = data.filter(d => plansToShow.includes(d.id));
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível obter os dados.", "error");
    }
  }
};
</script>

<style scoped>
ul li {
  list-style: none;
  padding: 0 !important;
  margin: 0 !important;
}
.mr-2 {
  margin-right: 5px;
}
.title {
  color: #005663;
  font-weight: bold;
}
.sub-title {
  font-weight: bold;
  color: #3f3e3e;
}
.box .f16 {
  font-size: 13px;
  font-weight: 400;
  color: #494848;
}
.card-title {
  font-size: 30px;
  font-weight: bold;
  color: #005663;
}
.card-title-item {
  color: #a9cd84;
  font-weight: bold;
}
.card {
  color: #2e3092;
  background-color: #fafafa;
  border: 1px solid #a9cd84;
}
.card-body {
  padding: 10px;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.card-value {
  margin-top: 10px;
  font-size: 35px;
  font-weight: bold;
  color: #a9cd84;
}
.card span {
  color: #005663;
  font-weight: bold;
}
.card-value span {
  font-size: 14px;
  font-weight: normal;
  color: #979797;
}

.container_contratar {
  display: flex;
  justify-content: center;
}
button.btn-contratar {
  background-color: #005663;
  border: none;
  color: #fff;
  padding: 10px 60px;
  border-radius: 5px;
  font-size: 18px;
}
button:hover {
  cursor: pointer;
}
button.btn-contratar a {
  color: #fff;
}

.mobile {
  display: none;
}
.desktop {
  display: none;
}

@media (min-width: 1224px) {
  .desktop {
    display: block;
  }
}

@media (max-width: 1223px) {
  .mobile {
    display: block;
  }
}
</style>
